/* eslint-disable max-lines */
import { AccountDeletionReason } from '__generated__/graphql'
import { DataTestIDs, RouterPathes } from 'shared/constants'
import {
  DiscordLogoIcon,
  MetamaskLogoIcon,
  TelegramLogoIcon,
  TwitterLogoIcon
} from 'shared/icons'

// NOTE: This functionality is not working from BE side, should be removed or added depending on future requirements
// export const PRIVACY_SETTINGS_TITLE = 'Privacy'
// export const PRIVACY_SETTINGS: UserSettingSecondaryItem[] = [
//   {
//     name: 'Show my profile to other users',
//     id: 'showProfile',
//     isMain: true
//   },
//   {
//     name: 'Show my Achievements to other users',
//     id: 'showAchievements',
//     isMain: false
//   },
//   {
//     name: 'Show my stats to other users',
//     id: 'showSetups',
//     isMain: false
//   },
//   {
//     name: 'Show my setups to other users',
//     id: 'showStats',
//     isMain: false
//   },
//   {
//     name: 'Show my gaming history to other users',
//     id: 'showBettingHistory',
//     isMain: false
//   },
//   {
//     name: 'Allow other users tag me in chat',
//     id: 'allowTagInChat',
//     isMain: false
//   },
//   {
//     name: 'Allow other users invite me to 1 vs 1 game',
//     id: 'allowInviteIn1vs1Game',
//     isMain: false
//   }
// ]

// NOTE: This functionality is not working from BE side, should be removed or added depending on future requirements
// export const EMAIL_NOTIFICATION_SETTINGS_TITLE = 'Email notifications'
// export const EMAIL_NOTIFICATION_SETTINGS: UserSettingSecondaryItem[] = [
//   {
//     name: 'Send notifications to email',
//     id: 'sendNotificationsToEmail',
//     isMain: true
//   },
//   {
//     name: 'Notify me of the results of my games',
//     id: 'notifyBetsResult',
//     isMain: false
//   },
//   {
//     name: 'Notify you about gaming invitations',
//     id: 'notifyBettingInvitation',
//     isMain: false
//   },
//   {
//     name: 'Notify me of new achievements',
//     id: 'notifyNewAchievements',
//     isMain: false
//   },
//   {
//     name: 'Notify about updates, enhancements, etc.',
//     id: 'notifyUpdates',
//     isMain: false
//   }
// ]

export const MAIN_SETTINGS = {
  NAME: {
    name: 'Name',
    buttonText: 'Change name',
    dataTestIdLocator: DataTestIDs.userSettingsName
  }
}

/** Settings entry that downloads the user's data (FE-331). */
export const EXPORT_DATA_SETTINGS = {
  title: 'Export my data',
  subtitle: 'Download a ZIP with your predictions history as CSV',
  preparing: 'Preparing your file… This can take up to a minute.',
  button: 'Export',
  startedTitle: 'Export ready',
  startedDescription: 'Your download has started.',
  errorTitle: 'Export failed'
}

/** The backend's grace period, until the preview says otherwise (FE-331). */
export const DELETE_ACCOUNT_GRACE_PERIOD_DAYS = 30

/** Settings entry and dialog of the account deletion (FE-331). */
export const DELETE_ACCOUNT_SETTINGS = {
  title: 'Delete account',
  subtitle: `Signs you out everywhere. Sign in within ${DELETE_ACCOUNT_GRACE_PERIOD_DAYS} days to restore it.`,
  button: 'Delete',
  heading: 'Delete account',
  failedTitle: 'Account not deleted',
  scheduledTitle: 'Account deletion scheduled'
}

/** `requestAccountDeletion` reasons, in the order the dialog lists them. */
export const DELETE_ACCOUNT_REASONS = [
  { value: AccountDeletionReason.SomethingBroken, label: "Something's broken" },
  {
    value: AccountDeletionReason.UsingAnotherService,
    label: 'Using another service'
  },
  { value: AccountDeletionReason.Other, label: 'Other' }
]

/** The backend's limit of the deletion comment. */
export const DELETE_ACCOUNT_COMMENT_MAX_LENGTH = 1000

export const MODALS_FIELDS = {
  CHANGE_NAME: {
    name: {
      label: 'Enter new name',
      value: 'username',
      placeholder: 'Type name'
    }
  },
  CHANGE_EMAIL: {
    email: {
      label: 'Email',
      value: 'email'
    }
  }
}

export const UPLOAD_FILE_TYPES = ['JPG', 'PNG', 'JPEG', 'SVG']
export const UPLOAD_FILE_TYPES_STRING =
  'image/png, image/jpeg, image/png, image/svg'

export const MAX_AVATAR_SIZE_MB = 1

export const MAX_SYMBOLS_CHANGE_BIO_INPUT_VALUE = 200

export enum SocialsOptions {
  twitter = 'twitter',
  discord = 'discord',
  telegram = 'telegram',
  metamask = 'metamask'
}

export const SOCAL_BUTTON_PARAMS_MAP = {
  [SocialsOptions.discord]: {
    name: 'Discord',
    icon: DiscordLogoIcon,
    ghostIcon: DiscordLogoIcon,
    verifiedBackgroundColor: '#5F3AF3',
    verifiedIconColor: ''
  },
  [SocialsOptions.twitter]: {
    name: 'X (Twitter)',
    icon: TwitterLogoIcon,
    ghostIcon: TwitterLogoIcon,
    verifiedBackgroundColor: '#E7E3FF',
    verifiedIconColor: ''
  },
  [SocialsOptions.telegram]: {
    name: 'Telegram',
    icon: TelegramLogoIcon,
    ghostIcon: TelegramLogoIcon,
    verifiedBackgroundColor: '#2398EE',
    verifiedIconColor: ''
  },
  [SocialsOptions.metamask]: {
    name: 'Wallet',
    icon: MetamaskLogoIcon,
    ghostIcon: MetamaskLogoIcon,
    verifiedBackgroundColor: '#FFFFFF',
    verifiedIconColor: ''
  }
}

export const SOCIAL_NETWORK_QUERY_KEY = 'social'

export const SOCIAL_NETWORK_ATTACH_CODE_PARAM = 'code'

export const SOCIAL_NETWORK_ATTACH_STATE_PARAM = 'state'

export const SOCIAL_OPTIONS_REDIRECT_URL = {
  DISCORD: `${window.location.protocol}\/\/${window.location.host}${RouterPathes.settings}?social=discord`,
  TWITTER: `${window.location.protocol}\/\/${window.location.host}${RouterPathes.settings}?social=twitter`
}
